// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__QjqZb","modal":"Modal_modal__DJDMv","botaoFechar":"Modal_botaoFechar__EYa6A"};